module.exports = __webpack_public_path__ + "assets/img/budapark4-1280.9d3c8bd2.webp";